// src/utils/string.js

export const normalizeString = (str) => {
  if (typeof str !== 'string' || !str) return "";
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
};

// Normalização para match entre banco e API externa: remove hífens e espaços extras.
// Resolve variações como "BOM JESUS - CENTRO" vs "BOM JESUS CENTRO".
export const normalizeForMatch = (str) => {
  if (typeof str !== 'string' || !str) return "";
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};
